import type { DocumentProps } from 'react-pdf'

// react-pdf's bundled pdfjs PDFDocumentProxy. Derived from react-pdf's exported
// props (the onLoadSuccess callback argument) so it always matches the pdfjs
// version react-pdf ships, rather than the top-level pdfjs-dist types.
type PDFDocumentProxy = Parameters<NonNullable<DocumentProps['onLoadSuccess']>>[0]

export default class PdfDocumentWrapper {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly document: PDFDocumentProxy,
  ) {}
}
